/* eslint-disable no-unneeded-ternary */
/* eslint-disable */
import { get } from 'lodash';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Switch } from '@mui/material';
import { formActions } from '../../../Actions';
import ListTable from '../../../Components/ListTable/ListTable';
import { inputHelper } from '../../../Helpers';
import { BackdropLoader } from '../../../Components/Loaders';
import { useAuth } from '@/Components/Auth/Login/auth';
import authActions from '@/Actions/auth.actions';

const TABLE_COLUMNS = [
	{
		title: 'UY Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Brand',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Sub Category',
		config: {
			type: 'DATA',
		},
	},
];

const SPECIAL_COLUMS = [
	{
		title: 'Client Variant Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Veg',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Enabled',
		config: {
			type: 'UPDATE',
		},
	},
];

const ACTION_COLUMNS = [
	{
		title: 'View',
		config: {
			type: 'VIEW',
		},
	},
];

const COLMAP = {
	'UY Id': 'id',
	Name: 'productName',
	Brand: 'Brand.name',
	Category: 'ProductCategory.productCategoryName',
	'Sub Category': 'ProductSubCategory.CategoryName',
	Veg: 'isVeg',
	Enabled: 'isEnabled',
	'Client Variant Id': 'clientVariantId',
};

const ComboListPage = (props) => {
	const {
		fetchCombos, toggleDisableCombo, data, query, searchBy, navState, userList, fetchUserList,
	} = props;

	// const { userConfig } = useAuth();
	// useEffect(async () => {
	// 	fetchUserList();
	// }, []);
	// // function page role of user access

	// const map = new Map(userList.map((item) => [item.value, item.label]));
	// const role = Object.keys(userConfig?.userRoles);
	// const userRoles = [];
	// role.forEach((ele) => {
	// 	userRoles.push(ele);
	// });
	// const pageRole = navState['/products']?.submenu?.['/products/combos']?.rolesMapped;
	// const findMatchingRole = userRoles.filter((ele) => pageRole.includes(Number(ele)));
	// const roleDetails = findMatchingRole.map((role) => {
	// 	const key = Number(role);
	// 	const name = map.get(key);
	// 	return {
	// 		role: key, name,
	// 	};
	// });
	// const isInternal = roleDetails.some((item) => item.name === 'Internal' || item.name === 'CXO Office' || item.name === 'Production' || item.name === 'Procurement' || item.name === 'Distribution And Supply Chain');
	// const access = findMatchingRole.length > 0 ? userConfig?.userDetails?.level : false;
	// let permit;
	// if (access === false) {
	// 	permit = false;
	// } else {
	// 	permit = isInternal && access !== 1;
	// }
	const [isLoading, setIsLoading] = useState(false);

	const handleEnable = (e) => {
		const { fieldValue, dataset } = inputHelper(e);

		toggleDisableCombo({
			entity: 'COMBOS',
			req: {
				params: {
					combo_id: dataset.id,
					enable: fieldValue,
				},
			},
			method: 'ENABLE',
		});
	};

	const SPECIAL_ITEMS = {
		'Client Variant Id': (id, clientVariantId) => {
			const item = data.find((item) => item.id === id)?.ProductVariant;
			return item?.map((item) => {
				return (
					<div className='flex gap-1 items-start' key={item.id}>
						{item?.clientVariantId}
					</div>
				);
			});
		},
		Veg: (id, isVeg) => {
			return (
				<div
					className={`dot-container small ${
						isVeg ? 'veg' : 'non-veg'
					}`}
				>
					<div className='dot' />
				</div>
			);
		},
		Enabled: (id, isEnabled) => {
			return (
				<Switch
					name='customization'
					value='customization'
					size='small'
					color='primary'
					// disabled={permit ? false : true}
					onChange={handleEnable}
					defaultChecked={isEnabled}
					inputProps={{
						'data-id': id,
						'data-type': 'COMBO',
					}}
				/>
			);
		},
	};

	const fetchComboFunc = async () => {
		setIsLoading(true);
		await fetchCombos({
			entity: 'COMBOS',
			req: {
				params: {},
			},
			method: 'LIST',
		});
		setIsLoading(false);
	};

	useEffect(() => {
		fetchComboFunc();
	}, []);

	const generatedData = () => {
		return data.filter((combo) => {
			if (searchBy?.title === 'Client Variant Id') {
				return combo.ProductVariant.some((variant) => {
					return String(variant?.clientVariantId).toLowerCase().indexOf(query?.trim()?.toLowerCase()) !== -1;
				});
			}
			return (
				get(combo, COLMAP?.[searchBy?.title])
					?.toLowerCase()
					?.indexOf(query?.trim()?.toLowerCase()) !== -1
			);
		});
	};
	return (
		<div className='list-page-root'>
			<BackdropLoader showProgress isLoading={isLoading} />
			<ListTable
				fixedHeaderTop={0}
				colMap={COLMAP}
				columns={TABLE_COLUMNS}
				data={generatedData()}
				actions={[...SPECIAL_COLUMS, ...ACTION_COLUMNS]}
				special={SPECIAL_ITEMS}
			/>
		</div>
	);
};

const mapStateToProps = (state) => {
	const data = state.form.COMBOS.data.LIST;
	const { navState } = state.navigation;
	const { userList } = state.auth;
	return {
		data,
		navState,
		userList,
	};
};

const mapDispatchToProps = {
	fetchCombos: formActions.gateway,
	toggleDisableCombo: formActions.gateway,
	fetchUserList: authActions.fetchUserList,
};

export default connect(mapStateToProps, mapDispatchToProps)(ComboListPage);
